import { MODULE_NAME } from '../constants';

export const INIT_PENDING = `${MODULE_NAME}/INIT_PENDING`;
export const INIT_DONE = `${MODULE_NAME}/INIT_DONE`;
